import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Users, Radio, Smartphone } from "lucide-react";
import { StatCard } from "@/components/DashLayout";
import { api, getActiveSubdomain } from "@/lib/api";

export default function Dashboard() {
  const { subdomain: paramSubdomain } = useParams();
  const activeSubdomain = getActiveSubdomain();
  const subdomain = activeSubdomain || paramSubdomain;
  const base = activeSubdomain ? "/admin" : `/site/${subdomain}/admin`;
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then(r => setD(r.data)).catch(() => { }); }, []);
  if (!d) return <div className="text-slate-500">Loading...</div>;
  return (
    <div className="space-y-8">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-3 sm:gap-4">
        <StatCard testid="admin-stat-customers" label="Customers" value={d.customers_total} accent="nav" />
        <StatCard testid="admin-stat-dealers" label="Dealers" value={d.dealers_total} accent="primary" />
        <StatCard testid="admin-stat-products" label="Packages" value={d.products_total} accent="primary" />
        <StatCard testid="admin-stat-expiring" label="Expiring 30d" value={d.expiring_30} accent="amber" hint="Next 30 days" />
        <StatCard testid="admin-stat-expired" label="Expired" value={d.expired_total} accent="danger" hint="Past due" />
        <StatCard testid="admin-stat-today" label="Revenue today" value={`₹${Math.round(d.revenue_today || 0).toLocaleString()}`} accent="accent" />
        <StatCard testid="admin-stat-month" label="Revenue MTD" value={`₹${Math.round(d.revenue_month || 0).toLocaleString()}`} accent="accent" />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
        <Link to={`${base}/customers`} className="bg-white border border-slate-200 rounded-xl p-6 hover:-translate-y-1 hover:shadow-md transition-all">
          <Users className="w-8 h-8 text-brand-primary" />
          <div className="mt-3 font-heading font-bold text-brand-nav">Add a customer</div>
          <div className="text-sm text-slate-500">Onboard DTH subscribers with dealer reference.</div>
        </Link>
        <Link to={`${base}/recharge`} className="bg-white border border-slate-200 rounded-xl p-6 hover:-translate-y-1 hover:shadow-md transition-all">
          <Radio className="w-8 h-8 text-brand-accent" />
          <div className="mt-3 font-heading font-bold text-brand-nav">Recharge Now</div>
          <div className="text-sm text-slate-500">Initiate a DTH recharge for any customer.</div>
        </Link>
        <Link to={`${base}/sim-details`} className="bg-white border border-slate-200 rounded-xl p-6 hover:-translate-y-1 hover:shadow-md transition-all">
          <Smartphone className="w-8 h-8 text-brand-primary" />
          <div className="mt-3 font-heading font-bold text-brand-nav">Manage SIM Details</div>
          <div className="text-sm text-slate-500">Add Lapu SIMs, login, and check balance.</div>
        </Link>
      </div>
    </div>
  );

}
